document.addEventListener('click', function (e) {

  const trigger = e.target.closest('.product-popup-trigger');

  if (trigger) {
    const modal = document.getElementById(trigger.dataset.popupId);

    if (modal) {
      modal.hidden = false;
    }
    return;
  }

  const modal = e.target.closest('.product-popup-modal:not([hidden])');

  if (
    modal &&
    !e.target.closest('.product-popup-modal__content')
  ) {
    modal.hidden = true;
  }

  if (e.target.closest('.product-popup-close')) {
    e.target.closest('.product-popup-modal').hidden = true;
  }
});